var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeeting = function SvgMeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_914_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4a2 2 0 110-4 2 2 0 010 4zM2 7.5a2 2 0 100-4 2 2 0 000 4zM.547 8.109a1 1 0 011.042.083l3.669 2.676H8a1 1 0 110 2H4.932a1 1 0 01-.59-.192L2 10.967v5.047h4.242a1 1 0 01.96.719l1.757 5.985a1 1 0 01-1.918.564l-1.548-5.268H1a1 1 0 01-1-1V9a1 1 0 01.547-.891zM23.453 8.109a1 1 0 00-1.042.083l-3.669 2.676H16a1 1 0 100 2h3.069a1 1 0 00.589-.192L22 10.967v5.047h-4.242a1 1 0 00-.96.719l-1.757 5.985a1 1 0 001.918.564l1.547-5.268H23a1 1 0 001-1V9a1 1 0 00-.547-.891zM20 5.5a2 2 0 104 0 2 2 0 00-4 0zM7.5 6.5a2 2 0 012-2h5a2 2 0 012 2V9a1 1 0 11-2 0V6.5h-5V9a1 1 0 11-2 0V6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5a1 1 0 100 2h15a1 1 0 100-2h-15z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_914_78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMeeting;